var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"col-lg-12 control-section"},[_c('ejs-treeview',{ref:"additionalMeasureTree",attrs:{"id":"additionalMeasureTreeId","fields":_vm.fields,"showCheckBox":true,"nodeChecked":_vm.nodeChecked}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }